import { Box, Typography } from "@mui/material";
import type { TalentExperienceData } from "./experienceTypes";
import useThemeStore from "@/shared/stores/useThemeStore";

interface TextDisplayProps {
  data?: TalentExperienceData;
}

export default function TextDisplay({ data = {} }: TextDisplayProps) {
  const { darkMode } = useThemeStore();
  if (!data.text) return null;

  return (
    <Box sx={{ p: 3, bgcolor: darkMode ? "#0d0c0a" : "#fafaf7" }}>
      {data.text.title && (
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: "1.25rem",
            textAlign: "center",
            color: darkMode ? "#f5eedc" : "#1c1b19",
            mb: 1.5,
          }}
        >
          {data.text.title}
        </Typography>
      )}
      {data.text.description && (
        <Typography
          sx={{
            fontSize: "0.9rem",
            lineHeight: 1.75,
            textAlign: "center",
            color: darkMode ? "rgba(245,238,220,0.7)" : "rgba(28,27,25,0.65)",
            whiteSpace: "pre-wrap",
          }}
        >
          {data.text.description}
        </Typography>
      )}
    </Box>
  );
}
